import React, { useRef } from 'react';
import { DialogTrigger } from 'react-aria-components';
import { type OrderedSubMenuItem } from './MegaMenu';
import { useEventListener } from 'usehooks-ts';
import {
  isKeyboardEvent,
  isMouseEvent,
  type NativePressEvent,
} from '@redturtle/qubicaamf-theme/helpers/events';
import { DropdownMenuItem } from './DropdownItem';

type DropdownMenuProps = {
  item: OrderedSubMenuItem;
};

const DropdownMenu: React.FC<DropdownMenuProps> = ({ item }) => {
  const { visible } = item;
  const dropdownTriggerRef = useRef<HTMLButtonElement>(null);

  function closeMenuFromBlockLink(e: NativePressEvent) {
    const link = (e.target as HTMLElement)?.closest('a');
    if (link) {
      const isInsideNavMenu = link.closest('#navmenu');
      if (!isInsideNavMenu || !dropdownTriggerRef.current) return; // Esci se non sei nel menu

      const open = dropdownTriggerRef.current.ariaExpanded === 'true';

      if (isKeyboardEvent(e)) {
        if (e.key === 'Enter' && open) {
          setTimeout(() => dropdownTriggerRef.current?.click(), 0); // Ritarda per sicurezza
        }
      } else if (isMouseEvent(e) && open) {
        setTimeout(() => dropdownTriggerRef.current?.click(), 0); // Ritarda per sicurezza
      }
    }
  }

  useEventListener('click', closeMenuFromBlockLink);
  useEventListener('keydown', closeMenuFromBlockLink);

  return visible ? (
    <DialogTrigger>
      <DropdownMenuItem item={item} ref={dropdownTriggerRef} />
    </DialogTrigger>
  ) : null;
};

export { DropdownMenu };
export type { DropdownMenuProps };
